// Icon imports
import DVert from '~/assets/svg/menu/D-Vert.svg'
import Localizacao from '~/assets/svg/menu/Localizacao.svg'
import Empreendimento from '~/assets/svg/menu/Empreendimento.svg'
import Plantas from '~/assets/svg/menu/Plantas.svg'
// import Easyhome from '~/assets/svg/menu/Easyhome.svg'
import Diferenciais from '~/assets/svg/menu/Diferenciais.svg'
import FaleConosco from '~/assets/svg/menu/Fale-conosco.svg'
// import AcompanheObra from '~/assets/svg/menu/AcompanheObra.svg'

export default [
  {
    icon: DVert,
    to: '#DVert',
  },
  {
    icon: Localizacao,
    to: '#Localizacao',
  },
  {
    icon: Empreendimento,
    to: '#Empreendimento',
  },
  {
    icon: Plantas,
    to: '#Plantas',
  },
  // {
  //   icon: AcompanheObra,
  //   to: 'acompanhe-a-obra/',
  // },
  {
    icon: Diferenciais,
    to: '#Diferenciais',
  },
  {
    icon: FaleConosco,
    to: 'fale-conosco/',
  },
]
